import React, { Component } from 'react';
import StripeCheckout from 'react-stripe-checkout';

import {Table, TableBody, TableRow, TableRowColumn} from 'material-ui/Table';
import {Card, CardText} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';

import Theme from '../Theme';
import Config from '../conf';
import Util from '../Util';

import 'whatwg-fetch';

class Confirm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      bookButtonDisabled: false,
      error: false,
      stripePaid: false,
      stripeToken: null,

      bookingCompleted: false
    };

    this.onToken = this.onToken.bind(this);
    this.sendToBackend = this.sendToBackend.bind(this);
    this.bookButtonClicked = this.bookButtonClicked.bind(this);
    this.retry = this.retry.bind(this);
  }

  bookButtonClicked() {
    this.setState({
      bookButtonDisabled: true
    });
    setTimeout(() => {
      this.setState({
        bookButtonDisabled: false
      });
    }, 5000);
  }

  retry() {
    this.setState({
      bookButtonDisabled: false,
      loading: false,
      error: false
    });
    this.onToken(this.state.stripeToken);
  }

  getBookingTime() {
    const date = this.props.details.date;
    const time = this.props.details.time;
    return Util.monthToString(date.getMonth()) + ' ' + date.getDate() + ', 2017 - ' + time;
  }

  sendToBackend(body) {
    // set to loading mode
    this.setState({
      loading: true
    });
    return new Promise((resolve, reject) => {
      fetch(Config.BACKEND_API_URL + 'landing/booking', {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      }).then(response => {
        return response.json().then(data => {
          if (data.status === 200) {
            resolve();
          } else {
            throw Error('response status from backend was ' + data.status + ' (data = ' + JSON.stringify(data) + ')');
          }
        });
      }).catch(err => {
        reject(err);
      });
    });
  }

  onToken(token) {
    // set paid flag
    this.setState({
      stripePaid: true,
      stripeToken: token
    });

    const description = 'B2C ' + this.props.details.carType + ' ' + this.props.details.washType + '\n' +
        'WhiteLabel ' + Config.CLIENT_NAME + ' Booking';
    const date = this.props.details.date;
    const timeSplit = this.props.details.time.split(' to ');
    const startTime = Util.toHoursMinutes(timeSplit[0]);
    const endTime = Util.toHoursMinutes(timeSplit[1]);
    const body = {
      tokenId: token ? token.id : null,
      description: description,
      name: this.props.details.name,
      email: this.props.details.email,
      phone: this.props.details.phone,
      address: this.props.details.address,
      numberPlate: this.props.details.numberPlate,
      carType: this.props.details.carType,
      washType: this.props.details.washType,
      extras: [], // @TODO
      date: {
        d: date.getDate(),
        m: date.getMonth(),
        y: date.getFullYear()
      },
      startTime: {
        h: startTime.hours,
        m: startTime.mins
      },
      endTime: {
        h: endTime.hours,
        m: endTime.mins
      },
      platform: 'white',
      whiteLabel: Config.CLIENT_NAME
    };
    this.sendToBackend(body).then(() => {
      this.setState({
        bookingCompleted: true
      });
    }).catch(err => {
      this.setState({
        error: true
      });
      console.log('Failed to send to backend: ' + err);
    });
  };

  render() {
    const styles = {
      card: {
        padding: 30,
        paddingTop: 40,
        textAlign: 'center',
        borderRadius: 12
      },
      title: {
        textAlign: 'center',
        margin: 0,
        color: Theme.palette.primary1Color,
        marginBottom: 20
      },
      button: {
        width: 100,
        marginTop: 20,
        marginLeft: 5,
        marginRight: 5
      },
      field: {
        padding: 0,
        margin: 0,
        marginTop: -15,
        width: '100%'
      },
      fieldHintStyle: {
        textAlign: 'center'
      },
      table: {
        paddingLeft: '25%',
        paddingRight: '25%',
        paddingTop: 30,
        paddingBottom: 20
      },
      nameCol: {
        textAlign: 'center',
        fontWeight: 'bold'
      },
      valueCol: {
        textAlign: 'center'
      }
    };

    const rows = [
      { name: 'Full Name', value: this.props.details.name },
      { name: 'Email Address', value: this.props.details.email },
      { name: 'Mobile Number', value: this.props.details.phone },
      { name: 'Car Address', value: this.props.details.address },
      { name: 'Number Plate', value: this.props.details.numberPlate },
      { name: 'Booking Time', value: this.getBookingTime() },
      { name: 'Wash Details', value: this.props.details.carType + ' ' + this.props.details.washTypeDisplay + ' $' +
          this.props.details.washPrice.toFixed(2) }
    ];

    return (
      <div>
      {!this.state.error && !this.state.loading && !this.state.bookingCompleted &&
        <Card style={styles.card}>
          <h2 style={styles.title}>
            Confirm And Pay
          </h2>

            {this.props.details.isSmallScreen ?
              <div>
              {rows.map((row) => {
                return (
                  <p key={row.name}>
                    <strong>{row.name}</strong>:
                    <br />
                    {row.value}
                  </p>
                );
              })}
              </div>
            :
              <Table selectable={false} style={styles.table}>
                <TableBody displayRowCheckbox={false}>
                {rows.map((row) => {
                  return (
                    <TableRow key={row.name}>
                      <TableRowColumn style={styles.nameCol}>{row.name}</TableRowColumn>
                      <TableRowColumn style={styles.valueCol}>{row.value}</TableRowColumn>
                    </TableRow>
                  );
                })}
                </TableBody>
              </Table>
            }

            <RaisedButton style={styles.button}
              label="Back" primary={true} onClick={this.props.back} />
            {this.state.stripePaid &&
                <RaisedButton
                  style={styles.button}
                  label="Book!"
                  primary={true}
                  disabled={this.state.bookButtonDisabled}
                  onClick={this.bookButtonClicked}
                />
            }
            {!this.state.stripePaid &&
              <StripeCheckout
                name={Config.CLIENT_NAME}
                image="./logo_stripe.png"
                currency="AUD"
                token={this.onToken}
                allowRememberMe={false}
                stripeKey={Config.STRIPE_PUBLIC_KEY}
                email={this.props.details.email}
              >
                <RaisedButton
                  style={styles.button}
                  label="Book"
                  primary={true}
                  disabled={this.state.bookButtonDisabled}
                  onClick={this.bookButtonClicked}
                />
              </StripeCheckout>
            }
        </Card>
      }
      {this.state.bookingCompleted &&
        <Card style={styles.card}>
          <h2 style={styles.title}>Finished</h2>
          <CardText>
            Thank you, your car wash has been booked. You will also receive SMS and email notifications shortly.
          </CardText>
        </Card>
      }
      {!this.state.error && this.state.loading && !this.state.bookingCompleted &&
        <Card style={styles.card}>
          <h2 style={styles.title}>Making your booking...</h2>
          <CardText>
            <CircularProgress />
          </CardText>
        </Card>
      }
      {this.state.error && !this.state.bookingCompleted &&
        <Card style={styles.card}>
          <h2 style={styles.title}>Error</h2>
          <CardText>
            <div>
              An error occurred.
            </div>
            <div>
              <RaisedButton
                style={{...styles.button,...{marginTop: 40}}}
                label="Retry"
                primary={true}
                onClick={this.retry}
              />
            </div>
          </CardText>
        </Card>
      }
      </div>
    );
  }
}

export default Confirm;



// WEBPACK FOOTER //
// ./src/components/Confirm.js